export default __webpack_public_path__ + "static/media/Female2.2afc576d.png";